import { Spin, Typography } from 'antd';
import React, { useEffect } from 'react';
import LilyLoading from '../../components/loading/lily-loading';
import { useFooterButton } from '../../pages/authentication/sign-up/signup-context';
import { useNavigate } from 'react-router-dom';

const Creating = () => {
    const { Title, Text, Link } = Typography;
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/auth/login');
        }, 3000);

        return () => clearTimeout(timer); // Clean up on unmount
    }, []);

    return (
        <div className='d-flex flex-column align-items-center justify-content-center h-100'>
            <Title className='mb-1' level={3}>
                Your account has been created!
            </Title>
            <LilyLoading />
            <Text className='description'>
                Redirecting to your dashboard.
            </Text>
            <Text className='description'>
                If you aren’t redirected, please log in <Link href='/auth/login' underline>here</Link>.
            </Text>
        </div>
    );
};

export default Creating;